
import { DatePicker, Form, Spin } from 'antd';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getFieldOptionsByCode } from '../../../../api/customForm';
import { getMerchantCode, getMerchantCode2, shallowEqualIgnoreOrder } from '../../utils/commonFun';
import { getBorderRadiusValue } from '../../utils/borderRadius';
import { MobileDateField, getDatePrecision } from '../mobilePickerFields';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const PickerPropsDefaults = {
    label: '',
    name: '',
    type: 'Date',
    dateType: 'date',
    format: 'YYYY-MM-DD',
    minDate: 'noLimit',
    maxDate: 'noLimit',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};
const { RangePicker } = DatePicker;

const StyledPickerRange = styled(RangePicker)`
    .ant-picker-input >input {
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
    }
`;
const StyledPickerDate = styled(DatePicker)`
    .ant-picker-input >input {
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
    }
`;

export const FormPicker = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var  _m, _o, _p, _q, _r, _s;
    var inputStyle = {
        width: '100%',
        borderRadius: getBorderRadiusValue((_s = style === null || style === void 0 ? void 0 : style.inputBorderRadius) !== null && _s !== void 0 ? _s : undefined),
        fontSize: (_m = style === null || style === void 0 ? void 0 : style?.inputFontSize) !== null && _m !== void 0 ? (isMobile ? _m/1.1 : _m) : undefined,
        color: (_o = style === null || style === void 0 ? void 0 : style.inputColor) !== null && _o !== void 0 ? _o : undefined,
        backgroundColor: (_p = style === null || style === void 0 ? void 0 : style.inputBackgroundColor) !== null && _p !== void 0 ? _p : undefined,
        borderColor: (_q = style === null || style === void 0 ? void 0 : style.inputBorderColor) !== null && _q !== void 0 ? _q : undefined,
        borderWidth: (_r = style === null || style === void 0 ? void 0 : style.inputBorderWidth) !== null && _r !== void 0 ? _r : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.inputPadding, isMobile),
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _n, _t, _u, _v, _w, _x, _y, _z;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : PickerPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : PickerPropsDefaults.name;
    var type = (_i = props === null || props === void 0 ? void 0 : props.type) !== null && _i !== void 0 ? _i : PickerPropsDefaults.type;
    var dateType = (_j = props === null || props === void 0 ? void 0 : props.dateType) !== null && _j !== void 0 ? _j : PickerPropsDefaults.dateType;
    var dateFormat = (_n = props === null || props === void 0 ? void 0 : props.format) !== null && _n !== void 0 ? _n : PickerPropsDefaults.format;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : PickerPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : PickerPropsDefaults.visible;
    var placeholder = (_t = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _t !== void 0 ? _t : '';
    var placeholder2 = (_u = props === null || props === void 0 ? void 0 : props.placeholder2) !== null && _u !== void 0 ? _u : '';
    var minDate = (_v = props === null || props === void 0 ? void 0 : props.minDate) !== null && _v !== void 0 ? _v : PickerPropsDefaults.minDate;
    var maxDate = (_w = props === null || props === void 0 ? void 0 : props.maxDate) !== null && _w !== void 0 ? _w : PickerPropsDefaults.maxDate;
    var minDateStr = (_x = props === null || props === void 0 ? void 0 : props.minDateStr) !== null && _x !== void 0 ? _x : '';
    var maxDateStr = (_y = props === null || props === void 0 ? void 0 : props.maxDateStr) !== null && _y !== void 0 ? _y : '';
    var disabled = (_z = props === null || props === void 0 ? void 0 : props.disabled) !== null && _z !== void 0 ? _z : PickerPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;

    const [fieldHidden, setFieldHidden] = useState(false);
    const [fieldLoading, setFieldLoading] = useState(false);
    const [dependFields, setDependFields] = useState({});
    const [lastDependFields, setLastDependFields] = useState({});
    const [currentMonth, setCurrentMonth] = useState(dayjs().format('YYYY-MM'));
    const [pickerSetting, setPickerSetting] = useState(null);
    const [savePickerSetting, setSavePickerSetting] = useState([]);
    const todayDate = useMemo(()=>{
        // const date = new Date();
        // const year = date.getFullYear();
        // let month = date.getMonth() + 1;
        // let day = date.getDate();

        // month = month < 10 ? '0' + month : month;
        // day = day < 10 ? '0' + day : day;

        // return year+'-'+month+'-'+day;
        return dayjs().format(dateFormat || 'YYYY-MM-DD');
    }, [dateFormat])
    
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    const handleGetDisabledDate = useCallback((current)=>{
        if(_a.fieldSource?.type === 'api') {
            if(fieldLoading) return true;
            if(!pickerSetting?.length) return false;

            const dateStr = current.format(dateFormat || 'YYYY-MM-DD');
            return current < dayjs(currentMonth).startOf('month') || current > dayjs(currentMonth).endOf('month') || pickerSetting.includes(dateStr);
        }
        else {
            return false;
        }
    }, [_a.fieldSource?.type, currentMonth, dateFormat, fieldLoading, pickerSetting])

    const handleGetDisabledTime = useCallback((current)=>{
        // 如果用户选择的不是今天，时间不限制
        if((minDate !== 'today' && maxDate !== 'today') && 
            (minDate === 'noLimit' || !minDateStr) && 
            (maxDate === 'noLimit' || maxDateStr)
        ) {
            return {};
        }
        
        const min_date_js = minDate === 'today' ? dayjs(todayDate) : minDateStr ? dayjs(minDateStr) : null;
        const max_date_js = maxDate === 'today' ? dayjs(todayDate) : maxDateStr ? dayjs(maxDateStr) : null;

        let disabledHoursArr = [];

        // --- 处理 min_date_js 限制 ---
        // 条件：存在 min_date_js，且用户选中的日期刚好是 min_date_js 所在的那一天
        if (min_date_js && current.isSame(min_date_js, 'day')) {
            const minHour = min_date_js.hour();

            // 收集小于 minHour 的所有小时
            for (let i = 0; i < minHour; i++) {
                disabledHoursArr.push(i);
            }

            // 如果当前小时等于边界小时，收集小于 minMinute 的所有分钟
            // (这里在 disabledMinutes 回调里处理)
        }

        // --- 处理 maxDate 限制 ---
        // 条件：存在 maxDate，且用户选中的日期刚好是 maxDate 所在的那一天
        if (max_date_js && current.isSame(max_date_js, 'day')) {
            const maxHour = max_date_js.hour();

            // 收集大于 maxHour 的所有小时
            for (let i = maxHour + 1; i < 24; i++) {
                disabledHoursArr.push(i);
            }
        }

        return {
            // 合并两端禁用的小时
            disabledHours: () => disabledHoursArr,

            // 动态判断分钟
            disabledMinutes: (selectedHour) => {
                let minutes = [];

                // 碰触下限小时：禁用小于 minMinute 的分钟
                if (min_date_js && current.isSame(min_date_js, 'day')) {
                    const minHour = min_date_js.hour();
                    if (selectedHour === minHour) {
                        for (let i = 0; i < min_date_js.minute(); i++) {
                            minutes.push(i);
                        }
                    }
                }

                // 碰触上限小时：禁用大于 maxMinute 的分钟
                if (max_date_js && current.isSame(max_date_js, 'day')) {
                    const maxHour = max_date_js.hour();
                    if (selectedHour === maxHour) {
                        for (let i = max_date_js.minute() + 1; i < 60; i++) {
                            minutes.push(i);
                        }
                    }
                }

                return minutes;
            },
        };

        const today_date_str = dayjs(todayDate);
        if (!current || !current.isSame(today_date_str, 'day')) {
            return {};
        }

        // 如果选的是今天，禁用今天当前时间（或指定12点）之前的时和分
        const currentHour = today_date_str.hour();     // 也可以固定设为 12
        const currentMinute = today_date_str.minute(); // 也可以固定设为 0

        return minDate === 'today' ? {
            // 禁用小时：小于 minDateTime 小时数的不能选
            disabledHours: () => {
                const hours = [];
                for (let i = 0; i < currentHour; i++) {
                hours.push(i);
                }
                return hours;
            },
            // 禁用分钟：当选中的小时等于 minDateTime 的小时时，禁用小于当前分钟数的值
            disabledMinutes: (selectedHour) => {
                if (selectedHour === currentHour) {
                const minutes = [];
                for (let i = 0; i < currentMinute; i++) {
                    minutes.push(i);
                }
                return minutes;
                }
                return [];
            },
        } : {
            // 禁用大于目标小时的选项（比如大于 12 的 13~23 点）
            disabledHours: () => {
                const hours = [];
                for (let i = currentHour + 1; i < 24; i++) {
                    hours.push(i);
                }
                return hours;
            },
            // 当选中的小时等于目标小时（如 12点）时，禁用大于目标分钟的选项
            disabledMinutes: (selectedHour) => {
                if (selectedHour === currentHour) {
                    const minutes = [];
                    for (let i = currentMinute + 1; i < 60; i++) {
                        minutes.push(i);
                    }
                    return minutes;
                }
                return [];
            },
        };
    }, [minDate, maxDate, minDateStr, maxDateStr, todayDate])

    function getMonthDays(monthStr) {
        const start = dayjs(monthStr).startOf('month'); // 月初
        const end = dayjs(monthStr).endOf('month');     // 月末
        const days = [];

        let current = start;

        while (current.isBefore(end) || current.isSame(end, 'day')) {
            days.push(current.format('YYYY-MM-DD'));
            current = current.add(1, 'day');
        }

        return days;
    }

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])

    useEffect(()=>{
        const fetchData = async () => {
            let res = null;
            if(_a?.fieldSource?.type === 'api' && _a?.fCode) {
                //如果options是通过api获取，走这里�?
                if(!fieldLoading) {
                    if(_a?.fieldSource?.additionInfo?.month) {
                        if(dayjs(currentMonth) < dayjs(todayDate).startOf('month')) {
                            //比今天早的时间不能预�?
                            setPickerSetting(getMonthDays(currentMonth));
                            return;
                        }
                    }
                    let dependValues = {};
                    let fullField = true;
                    if(_a?.fieldSource?.depends?.length) {
                        //需要获取其他字段的值来决定options，才发请�?
                        _a?.fieldSource?.depends?.forEach(item=>{
                            if(!dependFields[item.fromField]) {
                                fullField = false;
                            }
                            else if((dependFields[item.fromField]?.isRequired && dependFields[item.fromField]?.value) || !dependFields[item.fromField]?.isRequired) {
                                dependValues[item.targetParam] = dependFields[item.fromField]?.value;
                            }
                            else {
                                fullField = false;
                            }
                        })
                    }
                    if(fullField) {
                        if(_a?.fieldSource?.additionInfo?.month) {
                            dependValues[_a?.fieldSource?.additionInfo?.month] = currentMonth;
                        }
                        const c_pickSetting = savePickerSetting.find(s_item=>Object.keys(dependValues).every(d_key=>s_item[d_key] === dependValues[d_key]));
                        if(c_pickSetting) {
                            setPickerSetting(c_pickSetting.options);
                            return;
                        }
                        //依赖值发生变化，原值清空重新选择
                        _a?.formRef.setFieldValue(name, undefined);
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: undefined,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                        setFieldLoading(true);
                        const merchantCode = getMerchantCode(_a?.cmCode, 'form');
                        const getRes = await getFieldOptionsByCode({
                            "formCode": _a?.fCode,
                            "fieldCode": name,
                            "dependValues": dependValues
                        }, merchantCode || getMerchantCode2(_a?.cmCode), merchantCode ? null : 'form').catch(error => {
                            return null; // 必须 return，否�?getRes �?undefined
                        });
                        setFieldLoading(false);
                        if(getRes?.options?.length) {
                            const data1 = getRes?.options.filter(o_item=>o_item.disabled);
                            const data2 = data1.map(o_item=>(dayjs(o_item.value).format(dateFormat || 'YYYY-MM-DD')));
                            setPickerSetting(data2);
                            setSavePickerSetting(prev=>([
                                ...prev,
                                {
                                    ...dependValues,
                                    options: data2
                                }
                            ]))
                        }
                        else {
                            setPickerSetting(null);
                        }
                    }
                }
            }
            else {
                setPickerSetting(res);
            }
        };
        
        fetchData();
    }, [_a?.fieldSource?.type, _a?.fCode,
        _a?.fieldSource?.type === 'api' ? (_a?.fieldSource?.depends?.length ? dependFields : null) : null,
        _a?.fieldSource?.additionInfo?.month ? currentMonth : null
    ])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
        if(_a?.fieldSource?.type === 'api' && _a?.fieldSource?.depends?.length) {
            let depend_fields = {};
            _a?.fieldSource?.depends?.forEach(item=>{
                depend_fields[item.fromField] = _a?.allFieldValues[item.fromField];
            })
            if (!shallowEqualIgnoreOrder(lastDependFields, depend_fields)) {
                setDependFields(depend_fields);
                setLastDependFields(depend_fields);
            }
        }
    }, [_a?.fieldSource, _a?.allFieldValues])

    useEffect(()=>{
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    // Mobile 滚轮选择器配置：precision / min / max（dayjs 或 undefined）
    const mobilePrecision = useMemo(()=>getDatePrecision(dateType, dateFormat || 'YYYY-MM-DD'), [dateType, dateFormat]);
    const minDayjs = useMemo(()=>{
        if(minDate === 'noLimit') return undefined;
        if(minDate === 'today') return dayjs(todayDate, dateFormat || 'YYYY-MM-DD');
        if(minDateStr) return dayjs(minDateStr, dateFormat || 'YYYY-MM-DD');
        return undefined;
    }, [minDate, minDateStr, dateFormat, todayDate]);
    const maxDayjs = useMemo(()=>{
        if(maxDate === 'noLimit') return undefined;
        if(maxDate === 'today') return dayjs(todayDate, dateFormat || 'YYYY-MM-DD');
        if(maxDateStr) return dayjs(maxDateStr, dateFormat || 'YYYY-MM-DD');
        return undefined;
    }, [maxDate, maxDateStr, dateFormat, todayDate]);
    // mobile 端确认后同步 allFieldValues（与桌面 onChange 行为一致）
    const handleMobileValueChange = (val)=>{
        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
            ...prevData,
            [name]: {
                value: val,
                isRequired: prevData[name]?.isRequired,
                type: prevData[name]?.type
            }
        }))
    }

    return !calVisible && !fieldHidden ? null : (
        <Spin spinning={fieldLoading}><div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            name={name}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, message: requiredText}] : []}
        >
            {isMobile ? (
                // Mobile：底部弹出的滚轮选择器（年/月/日/时/分/秒按 precision 显示对应列）
                <MobileDateField
                    isRange={type === 'Range'}
                    format={dateFormat}
                    precision={mobilePrecision}
                    min={minDayjs}
                    max={maxDayjs}
                    placeholders={type === 'Range' ? [placeholder, placeholder2] : [placeholder]}
                    style={inputStyle}
                    disabled={disabled}
                    title={label}
                    onValue={handleMobileValueChange}
                />
            ) : (
                type === 'Range' ? <StyledPickerRange 
                    style={inputStyle}
                    showTime={dateType === 'showTime' ? true : false}
                    picker={dateType === 'showTime' ? 'date' : dateType}
                    format={dateFormat}
                    placeholder={[placeholder, placeholder2]}
                    inputReadOnly={true}
                    minDate={minDate === 'noLimit' ? undefined : 
                        minDate === 'today' ? dayjs(todayDate, dateFormat || 'YYYY-MM-DD') : 
                        minDateStr ? dayjs(minDateStr, dateFormat || 'YYYY-MM-DD') : ''}
                    maxDate={maxDate === 'noLimit' ? undefined : 
                        maxDate === 'today' ? dayjs(todayDate, dateFormat || 'YYYY-MM-DD') : 
                        maxDateStr ? dayjs(maxDateStr, dateFormat || 'YYYY-MM-DD') : ''}
                    $inputFontSize={inputStyle.fontSize}
                    onChange={(dates, dateStrings)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: dateStrings,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    disabled={disabled}
                />  : <StyledPickerDate
                    style={inputStyle}
                    showTime={dateType === 'showTime' ? true : false}
                    picker={dateType === 'showTime' ? 'date' : dateType}
                    format={dateFormat}
                    placeholder={placeholder}
                    inputReadOnly={true}
                    minDate={minDate === 'noLimit' ? undefined : 
                        minDate === 'today' ? dayjs(todayDate, dateFormat || 'YYYY-MM-DD') : 
                        minDateStr ? dayjs(minDateStr, dateFormat || 'YYYY-MM-DD') : ''}
                    maxDate={maxDate === 'noLimit' ? undefined : 
                        maxDate === 'today' ? dayjs(todayDate, dateFormat || 'YYYY-MM-DD') : 
                        maxDateStr ? dayjs(maxDateStr, dateFormat || 'YYYY-MM-DD') : ''}
                    disabledDate={handleGetDisabledDate}
                    disabledTime={handleGetDisabledTime}
                    $inputFontSize={inputStyle.fontSize}
                    onChange={(date, dateString)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: dateString,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    onPanelChange={(value, mode)=>{
                        setCurrentMonth(value.format('YYYY-MM'));
                    }}
                    disabled={disabled}
                    loading={fieldLoading}
                />
            )}
        </Form.Item>
    </div></Spin>
    );
}




